/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import React, { useEffect } from "react";

import {
	AcquisitionOptions,
	AcquisitionTypes,
	AssetsTypesOptions,
	StockAssetsTypes
} from "../../../../config/filingConstants";
import { IStocksExtractForm } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import { FormField, NumericInputField, SelectInputField, TextInputField } from "../../../fields";

type Props = {};

const CGStocksExtractDataForm: React.FC<Props> = (props: Props) => {
	const {} = props;

	const { values, errors, touched, setFieldValue, handleBlur, setFieldTouched } =
		useFormikContext<IStocksExtractForm>();

	useEffect(() => {
		const _TotalSale =
			Number(values.long_term?.SalePrice || 0) - Number(values.long_term.TransferExpense || 0);
		setFieldValue("long_term.TotalSaleConsideration", _TotalSale);
		const _CapitalGain = _TotalSale - Number(values.long_term?.TotalCostAcquisition || 0);
		setFieldValue("long_term.CapitalGains", _CapitalGain);
	}, [
		values.long_term?.TotalCostAcquisition,
		values.long_term?.SalePrice,
		values.long_term.TransferExpense
	]);

	useEffect(() => {
		const _TotalSale =
			Number(values.short_term?.SalePrice || 0) - Number(values.short_term.TransferExpense || 0);
		setFieldValue("short_term.TotalSaleConsideration", _TotalSale);
		const _CapitalGain = _TotalSale - Number(values.short_term?.TotalCostAcquisition || 0);
		setFieldValue("short_term.CapitalGains", _CapitalGain);
	}, [
		values.short_term?.TotalCostAcquisition,
		values.short_term?.SalePrice,
		values.short_term.TransferExpense
	]);

	return (
		<>
			<section className="mb-5">
				<p className="leading-para fw-bold text-primary">Listed Securities - Long term</p>

				<FormField label="Type of Assets" isRequired={true} sm={4}>
					<SelectInputField
						placeholder="Type of Assets"
						name="long_term.TypeAssets"
						options={UtilService.convertToArray(AssetsTypesOptions)}
						value={
							values.long_term.TypeAssets
								? [
										{
											label: AssetsTypesOptions[values.long_term.TypeAssets],
											value: values.long_term.TypeAssets
										}
								  ]
								: undefined
						}
						onChange={(selectedOption) => {
							if (selectedOption) {
								if (
									[
										StockAssetsTypes.Listed_Long_10_Per,
										StockAssetsTypes.Listed_Short_15_Per
									].includes(selectedOption.value)
								) {
									setFieldValue("long_term.STTPaid", "Yes");
								} else {
									setFieldValue("long_term.STTPaid", "No");
									setFieldValue("long_term.TotalFairMarketValue", "");
								}
								setFieldValue("long_term.Acquisition", undefined);
								setFieldValue("long_term.NameOfShare", "");
								setFieldValue("long_term.ISINCode", "");
								setFieldValue("long_term.TypeAssets", selectedOption.value);
							} else {
								setFieldValue("long_term.TypeAssets", undefined);
							}
						}}
						onBlur={handleBlur("long_termTypeAssets")}
						isInvalid={Boolean(errors?.long_term?.TypeAssets) && touched?.long_term?.TypeAssets}
						errorMsg={errors?.long_term?.TypeAssets}
					/>
				</FormField>

				{values.long_term.TypeAssets === StockAssetsTypes.Listed_Long_10_Per ? (
					<>
						<FormField label="Share acquired" sm={4}>
							<SelectInputField
								placeholder="Share acquired"
								name="long_term.Acquisition"
								options={UtilService.convertToArray(AcquisitionOptions)}
								value={
									values.long_term.Acquisition
										? [
												{
													label: AcquisitionOptions[values.long_term.Acquisition],
													value: values.long_term.Acquisition
												}
										  ]
										: undefined
								}
								onChange={(_selectedAcquisition) => {
									if (_selectedAcquisition) {
										setFieldValue("long_term.Acquisition", _selectedAcquisition.value);
										if (_selectedAcquisition.value === AcquisitionTypes.After_31_01_2018) {
											setFieldValue("long_term.ISINCode", "INNOTREQUIRD");
											setFieldValue("long_term.NameOfShare", "CONSOLIDATED");
											setFieldTouched("long_term.ISINCode", false);
											setFieldTouched("long_term.NameOfShare", false);
										} else {
											setFieldValue("long_term.ISINCode", "");
											setFieldValue("long_term.NameOfShare", "");
										}
									} else {
										setFieldValue("long_term.Acquisition", undefined);
									}
								}}
								onBlur={handleBlur("long_term.Acquisition")}
								isInvalid={
									Boolean(errors?.long_term?.Acquisition) && touched?.long_term?.Acquisition
								}
								errorMsg={errors?.long_term?.Acquisition}
								isDisabled={values.long_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per}
							/>
						</FormField>

						<FormField label="ISIN Code" sm={4}>
							<TextInputField
								name="long_term.ISINCode"
								value={values.long_term.ISINCode}
								onChange={(value) => {
									setFieldValue("long_term.ISINCode", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("long_term.ISINCode", values.long_term.ISINCode.trim());
								}}
								isInvalid={Boolean(errors?.long_term?.ISINCode) && touched?.long_term?.ISINCode}
								errorMsg={errors?.long_term?.ISINCode}
								isDisabled={
									values.long_term.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.long_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
						<FormField label="Name of Share" sm={4}>
							<TextInputField
								name="long_term.NameOfShare"
								value={values.long_term.NameOfShare}
								onChange={(value) => {
									setFieldValue("long_term.NameOfShare", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("long_term.NameOfShare", values.long_term.NameOfShare.trim());
								}}
								isInvalid={
									Boolean(errors?.long_term?.NameOfShare) && touched?.long_term?.NameOfShare
								}
								errorMsg={errors?.long_term?.NameOfShare}
								isDisabled={
									values.long_term.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.long_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
					</>
				) : null}

				<FormField label="Full value of consideration" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.SalePrice"
						value={values.long_term.SalePrice}
						onChange={(value) => {
							setFieldValue("long_term.SalePrice", value);
						}}
						onBlur={handleBlur("long_term.SalePrice")}
						isInvalid={Boolean(errors?.long_term?.SalePrice) && touched?.long_term?.SalePrice}
						errorMsg={errors?.long_term?.SalePrice}
					/>
				</FormField>

				<FormField label="Transfer Expenses" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.TransferExpense"
						value={values.long_term.TransferExpense}
						onChange={(value) => {
							setFieldValue("long_term.TransferExpense", value);
						}}
						onBlur={handleBlur("long_term.TransferExpense")}
						isInvalid={
							Boolean(errors?.long_term?.TransferExpense) && touched?.long_term?.TransferExpense
						}
						errorMsg={errors?.long_term?.TransferExpense}
					/>
				</FormField>

				<FormField label="Total Sale Consideration" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.TotalSaleConsideration"
						value={values.long_term.TotalSaleConsideration}
						onChange={(value) => {
							const CapitalGainsValue =
								Number(value) - Number(values.long_term.TotalCostAcquisition || 0);
							setFieldValue("long_term.TotalSaleConsideration", value);
							setFieldValue("long_term.CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("long_term.TotalSaleConsideration")}
						isInvalid={
							Boolean(errors?.long_term?.TotalSaleConsideration) &&
							touched?.long_term?.TotalSaleConsideration
						}
						errorMsg={errors?.long_term?.TotalSaleConsideration}
						isDisabled={true}
					/>
				</FormField>

				<FormField label="Total Fair Market Value" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.TotalFairMarketValue"
						value={values.long_term.TotalFairMarketValue}
						onChange={(value) => {
							setFieldValue("long_term.TotalFairMarketValue", value);
						}}
						onBlur={handleBlur("long_term.TotalFairMarketValue")}
						isInvalid={
							Boolean(errors?.long_term?.TotalFairMarketValue) &&
							touched?.long_term?.TotalFairMarketValue
						}
						errorMsg={errors?.long_term?.TotalFairMarketValue}
					/>
				</FormField>

				<FormField label="Total cost of Acquisition" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.TotalCostAcquisition"
						value={values.long_term.TotalCostAcquisition}
						onChange={(value) => {
							const CapitalGainsValue =
								Number(values.long_term.TotalSaleConsideration || 0) - Number(value);
							setFieldValue("long_term.TotalCostAcquisition", value);
							setFieldValue("long_term.CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("long_term.TotalCostAcquisition")}
						isInvalid={
							Boolean(errors?.long_term?.TotalCostAcquisition) &&
							touched?.long_term?.TotalCostAcquisition
						}
						errorMsg={errors?.long_term?.TotalCostAcquisition}
					/>
				</FormField>

				<FormField label="Capital Gains/(Loss)" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						name="long_term.CapitalGains"
						allowNegative={true}
						value={values.long_term.CapitalGains}
						onChange={(value) => setFieldValue("long_term.CapitalGains", value)}
						onBlur={handleBlur("long_term.CapitalGains")}
						isInvalid={Boolean(errors?.long_term?.CapitalGains) && touched?.long_term?.CapitalGains}
						errorMsg={errors?.long_term?.CapitalGains}
						isDisabled={true}
					/>
				</FormField>
			</section>

			<section className="mb-5">
				<p className="leading-para fw-bold text-primary">Listed Securities - Short term</p>

				<FormField label="Type of Assets" isRequired={true} sm={4}>
					<SelectInputField
						placeholder="Type of Assets"
						name="short_term.TypeAssets"
						options={UtilService.convertToArray(AssetsTypesOptions)}
						value={
							values.short_term.TypeAssets
								? [
										{
											label: AssetsTypesOptions[values.short_term.TypeAssets],
											value: values.short_term.TypeAssets
										}
								  ]
								: undefined
						}
						onChange={(selectedOption) => {
							if (selectedOption) {
								if (
									[
										StockAssetsTypes.Listed_Long_10_Per,
										StockAssetsTypes.Listed_Short_15_Per
									].includes(selectedOption.value)
								) {
									setFieldValue("short_term.STTPaid", "Yes");
								} else {
									setFieldValue("short_term.STTPaid", "No");
									setFieldValue("short_term.TotalFairMarketValue", "");
								}
								setFieldValue("short_term.Acquisition", undefined);
								setFieldValue("short_term.NameOfShare", "");
								setFieldValue("short_term.ISINCode", "");
								setFieldValue("short_term.TypeAssets", selectedOption.value);
							} else {
								setFieldValue("short_term.TypeAssets", undefined);
							}
						}}
						onBlur={handleBlur("short_term.TypeAssets")}
						isInvalid={Boolean(errors.short_term?.TypeAssets) && touched.short_term?.TypeAssets}
						errorMsg={errors.short_term?.TypeAssets}
					/>
				</FormField>

				{values.short_term.TypeAssets === StockAssetsTypes.Listed_Long_10_Per ? (
					<>
						<FormField label="Share acquired" sm={4}>
							<SelectInputField
								placeholder="Share acquired"
								name="short_term.Acquisition"
								options={UtilService.convertToArray(AcquisitionOptions)}
								value={
									values.short_term.Acquisition
										? [
												{
													label: AcquisitionOptions[values.short_term.Acquisition],
													value: values.short_term.Acquisition
												}
										  ]
										: undefined
								}
								onChange={(_selectedAcquisition) => {
									if (_selectedAcquisition) {
										setFieldValue("short_term.Acquisition", _selectedAcquisition.value);
										if (_selectedAcquisition.value === AcquisitionTypes.After_31_01_2018) {
											setFieldValue("short_term.ISINCode", "INNOTREQUIRD");
											setFieldValue("short_term.NameOfShare", "CONSOLIDATED");
											setFieldTouched("short_term.ISINCode", false);
											setFieldTouched("short_term.NameOfShare", false);
										} else {
											setFieldValue("short_term.ISINCode", "");
											setFieldValue("short_term.NameOfShare", "");
										}
									} else {
										setFieldValue("short_term.Acquisition", undefined);
									}
								}}
								onBlur={handleBlur("short_term.Acquisition")}
								isInvalid={
									Boolean(errors.short_term?.Acquisition) && touched.short_term?.Acquisition
								}
								errorMsg={errors.short_term?.Acquisition}
								isDisabled={values.short_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per}
							/>
						</FormField>

						<FormField label="ISIN Code" sm={4}>
							<TextInputField
								name="short_term.ISINCode"
								value={values.short_term.ISINCode}
								onChange={(value) => {
									setFieldValue("short_term.ISINCode", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("short_term.ISINCode", values.short_term.ISINCode.trim());
								}}
								isInvalid={Boolean(errors.short_term?.ISINCode) && touched.short_term?.ISINCode}
								errorMsg={errors.short_term?.ISINCode}
								isDisabled={
									values.short_term.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.short_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
						<FormField label="Name of Share" sm={4}>
							<TextInputField
								name="short_term.NameOfShare"
								value={values.short_term.NameOfShare}
								onChange={(value) => {
									setFieldValue("short_term.NameOfShare", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("short_term.NameOfShare", values.short_term.NameOfShare.trim());
								}}
								isInvalid={
									Boolean(errors.short_term?.NameOfShare) && touched.short_term?.NameOfShare
								}
								errorMsg={errors.short_term?.NameOfShare}
								isDisabled={
									values.short_term.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.short_term.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
					</>
				) : null}

				<FormField label="Full value of consideration" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.SalePrice"
						value={values.short_term.SalePrice}
						onChange={(value) => {
							setFieldValue("short_term.SalePrice", value);
						}}
						onBlur={handleBlur("short_term.SalePrice")}
						isInvalid={Boolean(errors.short_term?.SalePrice) && touched.short_term?.SalePrice}
						errorMsg={errors.short_term?.SalePrice}
					/>
				</FormField>

				<FormField label="Transfer Expenses" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.TransferExpense"
						value={values.short_term.TransferExpense}
						onChange={(value) => {
							setFieldValue("short_term.TransferExpense", value);
						}}
						onBlur={handleBlur("short_term.TransferExpense")}
						isInvalid={
							Boolean(errors.short_term?.TransferExpense) && touched.short_term?.TransferExpense
						}
						errorMsg={errors.short_term?.TransferExpense}
					/>
				</FormField>

				<FormField label="Total Sale Consideration" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.TotalSaleConsideration"
						value={values.short_term.TotalSaleConsideration}
						onChange={(value) => {
							const CapitalGainsValue =
								Number(value) - Number(values.short_term.TotalCostAcquisition || 0);
							setFieldValue("short_term.TotalSaleConsideration", value);
							setFieldValue("short_term.CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("short_term.TotalSaleConsideration")}
						isInvalid={
							Boolean(errors.short_term?.TotalSaleConsideration) &&
							touched.short_term?.TotalSaleConsideration
						}
						errorMsg={errors.short_term?.TotalSaleConsideration}
						isDisabled={true}
					/>
				</FormField>

				<FormField label="Total Fair Market Value" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.TotalFairMarketValue"
						value={values.short_term.TotalFairMarketValue}
						onChange={(value) => {
							setFieldValue("short_term.TotalFairMarketValue", value);
						}}
						onBlur={handleBlur("short_term.TotalFairMarketValue")}
						isInvalid={
							Boolean(errors.short_term?.TotalFairMarketValue) &&
							touched.short_term?.TotalFairMarketValue
						}
						errorMsg={errors.short_term?.TotalFairMarketValue}
					/>
				</FormField>

				<FormField label="Total cost of Acquisition" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.TotalCostAcquisition"
						value={values.short_term.TotalCostAcquisition}
						onChange={(value) => {
							const CapitalGainsValue =
								Number(values.short_term.TotalSaleConsideration || 0) - Number(value);
							setFieldValue("short_term.TotalCostAcquisition", value);
							setFieldValue("short_term.CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("short_term.TotalCostAcquisition")}
						isInvalid={
							Boolean(errors.short_term?.TotalCostAcquisition) &&
							touched.short_term?.TotalCostAcquisition
						}
						errorMsg={errors.short_term?.TotalCostAcquisition}
					/>
				</FormField>

				<FormField label="Capital Gains/(Loss)" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						name="short_term.CapitalGains"
						allowNegative={true}
						value={values.short_term.CapitalGains}
						onChange={(value) => setFieldValue("short_term.CapitalGains", value)}
						onBlur={handleBlur("short_term.CapitalGains")}
						isInvalid={Boolean(errors.short_term?.CapitalGains) && touched.short_term?.CapitalGains}
						errorMsg={errors.short_term?.CapitalGains}
						isDisabled={true}
					/>
				</FormField>
			</section>
		</>
	);
};

export default CGStocksExtractDataForm;
